export default __webpack_public_path__ + "static/media/pic5.c491b201.jpg";